const projects = {
  "myPageModal": {
    "menuLabel": "ម៉ឺនុយទំព័រខ្ញុំ",
    "account": {
      "editField": "កែ {{field}}",
      "saveField": "រក្សាទុក {{field}}",
      "cancelEdit": "បោះបង់ការកែ {{field}}",
      "saving": "កំពុងរក្សាទុក",
      "requiredError": "សូមបញ្ចូលតម្លៃ។",
      "phoneError": "ទម្រង់លេខទូរស័ព្ទមិនត្រឹមត្រូវ។",
      "emptyValue": "គ្មានតម្លៃ"
    },
    "logout": {
      "message": "តើអ្នកចង់ចេញមែនទេ?",
      "signingOut": "កំពុងចេញ"
    },
    "withdrawal": {
      "description": "សូមពិនិត្យសេចក្តីជូនដំណឹងខាងក្រោម ហើយយល់ព្រម។",
      "processing": "កំពុងដំណើរការ",
      "ownedProjectNotice": "អ្នកមិនអាចលុបគណនីបានទេ ខណៈដែលអ្នកជាម្ចាស់គម្រោង។ សូមលុបគម្រោង ឬផ្ទេរកម្មសិទ្ធិទៅសមាជិកផ្សេងជាមុនសិន។",
      "retentionNotice": "នៅពេលអ្នកលុបគណនី ព័ត៌មានគណនីដូចជាឈ្មោះ និងអាសយដ្ឋានអ៊ីមែលនឹងត្រូវលុបភ្លាមៗ ហើយមិនអាចយកមកវិញបានទេ។ បញ្ហា មតិយោបល់ រូបថត និងកំណត់ត្រាវាស់វែងដែលអ្នកបានទុកក្នុងគម្រោងនឹងនៅក្នុងគម្រោងសម្រាប់សមាជិកផ្សេងទៀត ដោយអ្នកនិពន្ធបង្ហាញជា \"{{unknownLabel}}\"។",
      "retryNotice": "ទិន្នន័យគណនីត្រូវបានលុបហើយ ប៉ុន្តែការលុបគណនីចូលប្រើមិនទាន់បានបញ្ចប់ទេ។ សូមចុចប៊ូតុង{{confirmLabel}}ម្តងទៀតដើម្បីបញ្ចប់។"
    },
    "permission": {
      "members": "សមាជិក",
      "memberList": "បញ្ជីសមាជិក",
      "roleGroup": "សិទ្ធិរបស់ {{name}}",
      "deleteMember": "លុប {{name}}",
      "noChanges": "គ្មានការផ្លាស់ប្តូរ",
      "changeCount": "ការផ្លាស់ប្តូរ {{count}}",
      "noMembers": "គ្មានសមាជិក",
      "deleteTitle": "លុបសមាជិក",
      "deleteMessage": "លុបសមាជិក '{{name}}' មែនទេ?",
      "deleteSubMessage": "សមាជិកដែលបានលុបមិនអាចស្តារវិញបានទេ",
      "emailLabel": "អ៊ីមែល",
      "emailRequired": "សូមបញ្ចូលអ៊ីមែល។",
      "emailInvalid": "ទម្រង់អ៊ីមែលមិនត្រឹមត្រូវ។ សូមពិនិត្យម្តងទៀត។",
      "emailExists": "អ៊ីមែលនេះមានរួចហើយ។",
      "serverError": "កំហុសម៉ាស៊ីនមេ។ សូមទាក់ទងអ្នកគ្រប់គ្រង។",
      "adding": "កំពុងបន្ថែម",
      "resetDone": "ការផ្លាស់ប្តូរត្រូវបានកំណត់ឡើងវិញ។",
      "noOwnProjectTitle": "មិនមានគម្រោងដែលអ្នកជាម្ចាស់ (owner) ទេ",
      "noOwnProjectDescription": "មានតែម្ចាស់ប៉ុណ្ណោះដែលអាចគ្រប់គ្រងសិទ្ធិគម្រោងបាន។",
      "transfer": {
        "title": "ផ្ទេរកម្មសិទ្ធិ",
        "warning": "បន្ទាប់ពីផ្ទេរ ម្ចាស់ថ្មីនឹងទទួលបានគម្រោងនេះ ហើយអ្នកនឹងត្រូវដកចេញពីគម្រោង។ មិនអាចត្រឡប់វិញបានទេ។",
        "emailLabel": "អ៊ីមែលម្ចាស់ថ្មី",
        "submit": "ផ្ទេរ",
        "transferring": "កំពុងផ្ទេរ",
        "notFound": "អ៊ីមែលនេះមិនមែនជាអ្នកប្រើដែលបានចុះឈ្មោះ ឬគណនីត្រូវបានបិទ ឬអ្នកលែងជាម្ចាស់គម្រោងនេះទៀតហើយ។",
        "titleConflict": "ម្ចាស់ថ្មីមានគម្រោងឈ្មោះដូចគ្នារួចហើយ ដូច្នេះមិនអាចផ្ទេរបានទេ។ សូមប្តូរឈ្មោះគម្រោង រួចព្យាយាមម្តងទៀត។",
        "invalidTarget": "មិនអាចផ្ទេរទៅខ្លួនឯង ឬទៅគណនីអ្នកគ្រប់គ្រងបានទេ ឬទម្រង់សំណើមិនត្រឹមត្រូវ។",
        "failed": "ការផ្ទេរកម្មសិទ្ធិបានបរាជ័យ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។"
      }
    },
    "select": {
      "noResult": "រកមិនឃើញលទ្ធផល"
    },
    "history": {
      "timeline": "ប្រវត្តិគម្រោង",
      "loadingMore": "កំពុងផ្ទុក"
    }
  },
  "queryState": {
    "projectListLoadFailed": "មិនអាចផ្ទុកបញ្ជីគម្រោងបានទេ",
    "ownProjectListLoadFailed": "មិនអាចផ្ទុកបញ្ជីគម្រោងដែលអ្នកជាម្ចាស់បានទេ",
    "memberListLoadFailed": "មិនអាចផ្ទុកបញ្ជីសមាជិកបានទេ",
    "droneImageListLoadFailed": "មិនអាចផ្ទុកបញ្ជីរូបភាពដ្រូនបានទេ",
    "droneImageSizeLoadFailed": "មិនអាចផ្ទុកទំហំដើមនៃរូបភាពដ្រូនបានទេ",
    "gcpFileLoadFailed": "មិនអាចផ្ទុកព័ត៌មានឯកសារ GCP បានទេ",
    "layerDataLoadFailed": "មិនអាចផ្ទុកបញ្ជីឯកសារបានទេ",
    "layerDataLoadFailedNamed": "មិនអាចផ្ទុកបញ្ជីឯកសារ {{name}} បានទេ",
    "drawingListLoadFailed": "មិនអាចផ្ទុកបញ្ជីប្លង់បានទេ",
    "drawingListLoadFailedNamed": "មិនអាចផ្ទុកបញ្ជី {{name}} បានទេ",
    "orthomosaicImageLoadFailed": "មិនអាចផ្ទុកការមើលជាមុនរូបភាព orthomosaic បានទេ",
    "earthworkZoneListLoadFailed": "មិនអាចផ្ទុកបញ្ជីតំបន់គណនាបានទេ",
    "earthworkSurfaceListLoadFailed": "មិនអាចផ្ទុកបញ្ជីប្លង់និងផ្ទៃរចនាបានទេ",
    "earthworkSurfaceNameLoadFailed": "មិនអាចផ្ទុកឈ្មោះផ្ទៃបានទេ",
    "earthworkEpochListLoadFailed": "មិនអាចផ្ទុកបញ្ជីស៊េរីពេលវេលាបានទេ",
    "earthworkPermissionLoadFailed": "មិនអាចផ្ទុកព័ត៌មានសិទ្ធិគម្រោងបានទេ",
    "earthworkPermissionChecking": "កំពុងពិនិត្យមើលសិទ្ធិគម្រោង",
    "earthworkProjectLoadFailed": "មិនអាចផ្ទុកព័ត៌មានគម្រោងបានទេ",
    "earthworkResultLoadFailed": "មិនអាចផ្ទុកលទ្ធផលគណនាការងារដីបានទេ",
    "earthworkStartFailed": "មិនអាចចាប់ផ្តើមការគណនាការងារដីបានទេ",
  },
  "earthwork": {
    "noSiteDrawingTitle": "គម្រោងនេះមិនមានប្លង់សម្រាប់ការងារដីផ្អែកលើតំបន់ទេ",
    "noSiteDrawingHint": "បន្ទាប់ពីប្លង់ត្រូវបានកំណត់សម្រាប់ការងារដីផ្អែកលើតំបន់ ហើយការបំប្លែងបានបញ្ចប់ សូមផ្ទុកទំព័រឡើងវិញដើម្បីឃើញវានៅទីនេះ។",
    "computeUnavailable": "មិនអាចគណនាបរិមាណការងារដីបានទេ ព្រោះមិនមានប្លង់សម្រាប់ការងារដីផ្អែកលើតំបន់។",
    "sidebarDisabled": {
      "noEarthworkSource": "មិនអាចបើកបានទេ ព្រោះគម្រោងនេះមិនមានប្លង់សម្រាប់ការងារដីផ្អែកលើតំបន់ ឬស្រទាប់បន្ទាត់",
      "sourceUnreadable": "មិនអាចបើកបានទេ ព្រោះមិនអាចផ្ទុកបញ្ជីប្លង់ ឬបញ្ជីស្រទាប់បាន",
      "needsCompletedTimeSeries": "សូមជ្រើសរើសស៊េរីពេលវេលាដែលបានបញ្ចប់ដើម្បីបើក",
      "timeSeriesUnreadable": "មិនអាចបើកបានទេ ព្រោះមិនអាចផ្ទុកបញ្ជីស៊េរីពេលវេលាបាន",
      "checking": "កំពុងពិនិត្យមើលថាអាចបើកបានឬអត់",
      "meshNotBuilt": "មិនអាចបើកបានទេ ព្រោះ 3D (mesh) មិនទាន់បានបង្កើតនៅឡើយ",
      "twoDNotBuilt": "មិនអាចបើកបានទេ ព្រោះ 2D (រូបភាព orthomosaic · DEM) មិនទាន់បានបង្កើតនៅឡើយ"
    }
  },
  "drawingBundle": {
    "expand": "ពង្រីកកញ្ចប់",
    "collapse": "បង្រួមកញ្ចប់",
    "memberCount": "ប្លង់ {{count}}",
    "expanding": "កំពុងបើកកញ្ចប់",
    "failed": "បើកកញ្ចប់មិនបានសម្រេច",
    "pending": "រង់ចាំបម្លែង {{count}}",
    "uploaded": "បានផ្ទុកឡើងកញ្ចប់ {{name}} — បានចុះបញ្ជីប្លង់ {{count}} នឹងបង្ហាញក្នុងកញ្ចប់បន្ទាប់ពីបម្លែងរួច",
    "uploadFailed": "ការផ្ទុកឡើងកញ្ចប់ {{name}} មិនបានសម្រេច — {{reason}}",
    "nameInput": "បញ្ចូលឈ្មោះកញ្ចប់"
  },
  "drawingPair": {
    "title": "ផ្ទុកឡើងប្លង់",
    "hint": "ប្លង់នីមួយៗត្រូវការ DXF តម្រឹមមួយ។",
    "drawingColumn": "ប្លង់",
    "alignmentColumn": "DXF តម្រឹម",
    "alignmentMissing": "គ្មាន DXF តម្រឹម",
    "pickAlignment": "ជ្រើសរើស DXF តម្រឹមសម្រាប់ {{name}}",
    "pick": "ជ្រើសរើស",
    "replace": "ប្តូរ",
    "unpairedCount": "ប្លង់ {{count}} គ្មាន DXF តម្រឹម",
    "orphanNotice": "DXF ដែលរកគូមិនឃើញ៖ {{names}}",
    "submit": "ផ្ទុកឡើង",
    "submitLabel": "ផ្ទុកឡើងគូប្លង់",
    "submitBlockedLabel": "ប្លង់ {{count}} គ្មាន DXF តម្រឹម — មិនអាចផ្ទុកឡើងបានទេ",
    "cancel": "បោះបង់",
    "close": "បិទ",
    "dwgRequired": "គ្មានឯកសារប្លង់ (.dwg) ។ សូមជ្រើសរើសប្លង់ជាមួយ DXF តម្រឹម។",
    "lonelyDxfSkipped": "មិនបានផ្ទុកឡើង DXF {{count}} ដែលគ្មានប្លង់ (.dwg) ត្រូវគ្នា។",
    "alignmentUploadFailed": "ការផ្ទុកឡើង DXF តម្រឹមមិនបានសម្រេច — {{names}}",
    "gapTitle": "ប្លង់ {{count}} នៅតែគ្មានតម្រឹម",
    "gapDescription": "ប្លង់ត្រូវបានផ្ទុកឡើងហើយ ប៉ុន្តែ DXF តម្រឹមនៅទទេ។ ប្លង់គ្មានតម្រឹមមិនអាចបង្កើតបានទេ។",
    "retry": "ផ្ទុកឡើងតម្រឹមម្តងទៀត",
    "retryLabel": "ផ្ទុកឡើង DXF តម្រឹមម្តងទៀត"
  },
  "sidebar": {
    "timeSeries": "ត្រួតពិនិត្យស៊េរីពេលវេលា",
    "calendar": "ប្រតិទិន",
    "road": "លាបផ្លូវ",
    "graph": "ក្រាហ្វ",
    "ship": "នាវា"
  },
  "menu": {
    "timeSeries": "ត្រួតពិនិត្យស៊េរីពេលវេលា",
    "roadDetection": "ការរកឃើញបញ្ហាលាបផ្លូវ"
  },
  "dashboard": {
    "title": "គម្រោង",
    "searchPlaceholder": "ស្វែងរកគម្រោង",
    "noProjects": "មិនមានគម្រោង",
    "noSearchedTags": "មិនមានស្លាកដែលត្រូវគ្នា",
    "loading": "កំពុងផ្ទុក...",
    "countLoading": "កំពុងពិនិត្យចំនួន",
    "filterApplied": "តម្រង, កំពុងអនុវត្ត {{count}}",
    "tagFilter": "តម្រងស្លាក"
  },
  "modal": {
    "addProject": "បន្ថែមគម្រោង",
    "editTimeSeries": "កែស៊េរីពេលវេលា",
    "editProject": "កែសម្រួលព័ត៌មានគម្រោង",
    "steps": {
      "location": "ទីតាំង",
      "projectInfo": "ព័ត៌មានគម្រោង",
      "addTimeSeries": "បន្ថែមស៊េរីពេលវេលា"
    },
    "projectName": "ឈ្មោះគម្រោង",
    "projectNamePlaceholder": "សូមបញ្ចូលឈ្មោះគម្រោង",
    "address": "អាសយដ្ឋាន",
    "location": "ទីតាំង",
    "changeLocation": "ប្តូរ",
    "addressSearchPlaceholder": "ស្វែងរកអាសយដ្ឋាន ឬចុចលើផែនទី",
    "infraType": "ប្រភេទហេដ្ឋារចនាសម្ព័ន្ធ",
    "infraTypeInputPlaceholder": "សូមបញ្ចូលប្រភេទហេដ្ឋារចនាសម្ព័ន្ធ",
    "objectType": "ប្រភេទវត្ថុ",
    "selectPlaceholder": "សូមជ្រើសរើស",
    "objectTypeExample": "ឧ. ស្ពាន",
    "tags": "ស្លាក",
    "tagsPlaceholder": "ជ្រើសរើសស្លាក ឬបន្ថែមថ្មី (Enter)",
    "memo": "កំណត់ចំណាំ",
    "memoPlaceholder": "សូមបញ្ចូលកំណត់ចំណាំ",
    "datePlaceholder": "សូមជ្រើសរើសកាលបរិច្ឆេទ",
    "comment": "មតិយោបល់",
    "commentPlaceholder": "សូមបញ្ចូលមតិយោបល់",
    "required": "&#42;",
    "cancel": "បោះបង់",
    "next": "បន្ទាប់",
    "previous": "ត្រឡប់",
    "save": "រក្សាទុក",
    "add": "បន្ថែម",
    "apply": "អនុវត្ត",
    "feedback": {
      "projectCreated": "ការបង្កើតគម្រោងបានជោគជ័យ",
      "projectCreateFailed": "ការបង្កើតគម្រោងបានបរាជ័យ",
      "duplicateProjectName": "មានឈ្មោះគម្រោងដូចគ្នាហើយ។",
      "timeSeriesOwnerOnly": "មានតែម្ចាស់គម្រោងប៉ុណ្ណោះដែលអាចបន្ថែម ឬកែស៊េរីពេលវេលាបាន។"
    },
    "state": {
      "addressSearchFailed": "មិនអាចផ្ទុកលទ្ធផលស្វែងរកអាសយដ្ឋានបានទេ",
      "addressNoResult": "រកមិនឃើញលទ្ធផល",
      "projectInfoLoadFailed": "មិនអាចផ្ទុកព័ត៌មានគម្រោងបានទេ",
      "timeSeriesInfoLoadFailed": "មិនអាចផ្ទុកព័ត៌មានស៊េរីពេលវេលាបានទេ"
    },
    "a11y": {
      "stepProgress": "ជំហាននៃដំណើរការ",
      "reselectInfraType": "ជ្រើសរើសប្រភេទហេដ្ឋារចនាសម្ព័ន្ធម្តងទៀត",
      "removeTag": "ដកស្លាក {{tag}}",
      "adding": "កំពុងបន្ថែម",
      "saving": "កំពុងរក្សាទុក",
      "addressSearching": "កំពុងស្វែងរកអាសយដ្ឋាន",
      "addressResults": "លទ្ធផលស្វែងរកអាសយដ្ឋាន",
      "tagsLoading": "កំពុងផ្ទុកស្លាក",
      "tagList": "បញ្ជីស្លាក",
      "projectInfoLoading": "កំពុងផ្ទុកព័ត៌មានគម្រោង",
      "timeSeriesInfoLoading": "កំពុងផ្ទុកព័ត៌មានស៊េរីពេលវេលា"
    }
  },
  "table": {
    "columns": {
      "name": "ឈ្មោះគម្រោង",
      "location": "ទីតាំង",
      "date": "កាលបរិច្ឆេទ",
      "status": "ស្ថានភាព",
      "actions": "ប្រតិបត្តិការ",
      "memo": "កំណត់ចំណាំ",
      "mappingStatus": "ស្ថានភាពការគូសផែនទីរូបភាព",
      "timeSeriesCount": "ស៊េរីពេលវេលា"
    },
    "status": {
      "completed": "បានបញ្ចប់",
      "processing": "កំពុងដំណើរការ",
      "pending": "កំពុងរង់ចាំ",
      "failed": "បរាជ័យ"
    },
    "addTimeSeries": "បន្ថែមស៊េរីពេលវេលា",
    "createNewProject": "សូមបង្កើតគម្រោងថ្មី។",
    "lastModified": "កែចុងក្រោយ",
    "memoSearch": "ស្វែងរកកំណត់ចំណាំ",
    "noMemoResults": "រកមិនឃើញកំណត់ចំណាំ",
    "noSearchResult": "រកមិនឃើញលទ្ធផល",
    "listLoading": "កំពុងផ្ទុកបញ្ជីគម្រោង",
    "searching": "កំពុងស្វែងរក"
  },
  "details": {
    "title": "ព័ត៌មានលម្អិតគម្រោង",
    "information": "ព័ត៌មានគម្រោង",
    "timeSeries": "ទិន្នន័យស៊េរីពេលវេលា",
    "noData": "មិនមានទិន្នន័យ",
    "projectName": "ឈ្មោះគម្រោង",
    "location": "ទីតាំង",
    "createdAt": "ថ្ងៃបង្កើត",
    "updatedAt": "ថ្ងៃកែ",
    "description": "ការពិពណ៌នា",
    "unknown": "មិនដឹង"
  },
  "map": {
    "title": "ទីតាំងគម្រោង",
    "noLocation": "មិនមានព័ត៌មានទីតាំង",
    "preview": "មើលទីតាំងជាមុន"
  },
  "tabs": {
    "information": "ព័ត៌មាន",
    "droneImage": "រូបភាពដ្រូន",
    "layerData": "ទិន្នន័យស្រទាប់",
    "terrainData": "ទិន្នន័យកម្ពស់ភូមិសាស្ត្រ",
    "referenceData": "ទិន្នន័យយោង"
  },
  "information": {
    "details": "ព័ត៌មានលម្អិត",
    "edit": "កែ",
    "address": "អាសយដ្ឋាន",
    "coordinates": "កូអរដោនេ",
    "latitude": "រយៈទទឹង",
    "longitude": "រយៈបណ្ដោយ",
    "infraType": "ប្រភេទហេដ្ឋារចនាសម្ព័ន្ធ/វត្ថុ",
    "tags": "ស្លាក",
    "memo": "កំណត់ចំណាំ",
    "thumbnail": "រូបភាពតូច",
    "noImage": "មិនមានរូបភាព",
    "noPreviewTarget": "គ្មានស៊េរីពេលវេលាសម្រាប់ទាញយករូបភាពមើលជាមុនទេ"
  },
  "layerTypes": {
    "stratum": "ស្រទាប់ដី",
    "designHeight": "កម្ពស់គម្រោង",
    "designProfile": "ដីដើម",
    "drawing": "គំនូរបច្ចេកទេស"
  },
  "dataTypes": {
    "image": "រូបភាព",
    "document": "ឯកសារ",
    "video": "វីដេអូ",
    "gis": "GIS",
    "line": "ស្រទាប់បន្ទាត់",
    "bim": "BIM",
    "pointCloud": "Point Cloud"
  },
  "droneImage": {
    "selectAll": "ជ្រើសរើសទាំងអស់",
    "uploadedImages": "រូបភាពដែលបានបញ្ចូល",
    "uploadingImages": "កំពុងបញ្ចូលរូបភាព",
    "targetImages": "រូបភាពដែលត្រូវបញ្ចូល",
    "totalSize": "ទំហំសរុប",
    "uploadImages": "បញ្ចូលរូបភាព",
    "uploadImagesCount": "បញ្ចូលរូបភាព",
    "uploading": "កំពុងបញ្ចូល",
    "uploadingMessage": "សូមរក្សាអេក្រង់នេះរហូតដល់ការផ្ទេរបានបញ្ចប់",
    "uploadSuccess": "ការបញ្ចូលរូបភាពបានបញ្ចប់ដោយជោគជ័យ។",
    "uploadFailed": "ការបញ្ចូលរូបភាពបានបរាជ័យ។",
    "deleteSuccess": "ការលុបរូបភាពបានបញ្ចប់ដោយជោគជ័យ។",
    "deleteFailed": "ការលុបរូបភាពបានបរាជ័យ។",
    "deleting": "កំពុងលុប...",
    "loading": "កំពុងផ្ទុក...",
    "noValidImages": "មិនមានឯកសាររូបភាពត្រឹមត្រូវ (.jpg, .jpeg)។",
    "addImagesGuide": "បន្ថែមរូបភាពនៅផ្ទាំងបន្ថែមរូបភាព"
  },
  "file": {
    "download": "ទាញយក",
    "delete": "លុប",
    "upload": "បញ្ចូល",
    "refresh": "ផ្ទុកឡើងវិញ",
    "downloadNamed": "ទាញយក {{name}}",
    "deleteNamed": "លុប {{name}}",
    "uploadNamed": "បញ្ចូល {{name}}",
    "previewNamed": "មើលជាមុន {{name}}",
    "deleteSuccess": "ការលុបឯកសារបានបញ្ចប់ដោយជោគជ័យ។",
    "deleteFailed": "ការលុបឯកសារបានបរាជ័យ។",
    "downloadFailed": "ការទាញយកឯកសារបានបរាជ័យ។",
    "uploading": "កំពុងបញ្ចូល",
    "uploadingMessage": "សូមរក្សាអេក្រង់នេះរហូតដល់ការផ្ទេរបានបញ្ចប់",
    "skippedUnsupported": "បានរំលងឯកសារ {{count}} ដែលមិនគាំទ្រទម្រង់។"
  },
  "layerRename": {
    "renameLayer": "ប្ដូរឈ្មោះ",
    "renameLayerNamed": "ប្ដូរឈ្មោះ {{name}}",
    "layerNameInput": "បញ្ចូលឈ្មោះស្រទាប់",
    "renameDuplicate": "ឈ្មោះនេះកំពុងប្រើប្រាស់រួចហើយ។ សូមបញ្ចូលឈ្មោះផ្សេង។",
    "renameInvalid": "ឈ្មោះមិនអាចប្រើបានទេ។ ឈ្មោះត្រូវមានពី 1 ដល់ 100 តួអក្សរ។",
    "renameNoPermission": "អ្នកគ្មានសិទ្ធិប្ដូរឈ្មោះស្រទាប់នេះទេ ឬវាមិនមានទៀតទេ។",
    "renameFailed": "ការប្ដូរឈ្មោះស្រទាប់បានបរាជ័យ។"
  },
  "timeSeries": {
    "mappingInfo": "ព័ត៌មានការគូសផែនទី",
    "imageMapping": "ការគូសផែនទីរូបភាព",
    "mappingRequest": "សំណើការគូសផែនទី",
    "requestCompleted": "សំណើបានបញ្ចប់",
    "gcpUpload": "បញ្ចូល GCP",
    "gcp": "GCP",
    "gcpAutoDetect": "រកឃើញស្វ័យប្រវត្តិ",
    "gcpAutoDetectHint": "បើកនៅពេល GCP ប្រើសញ្ញាសម្គាល់ស្តង់ដាររបស់ DroneSquare។ អាចបើកបានបន្ទាប់ពីបញ្ចូលឯកសារ GCP។",
    "gcpAutoDetectSaveFailed": "មិនអាចផ្លាស់ប្តូរការកំណត់រកឃើញ GCP ស្វ័យប្រវត្តិបានទេ។",
    "gcpAutoDetectBlocked": {
      "GCP_FILE_UNREADABLE": "ការរកឃើញស្វ័យប្រវត្តិមិនអាចអានឯកសារ $t(timeSeries.gcpGuide.unreadableFormats) បានទេ។ សូមរក្សាទុកជា csv ឬ xlsx ហើយបញ្ចូលម្តងទៀត។",
      "NO_PHOTOS": "អាចបើកការរកឃើញស្វ័យប្រវត្តិបាន បន្ទាប់ពីបញ្ចូលរូបថតដ្រូន។"
    },
    "gcpFilesUsedTogether": "ប្រសិនបើមានឯកសារ GCP ច្រើន ឯកសារទាំងអស់នឹងត្រូវប្រើជាមួយគ្នា។",
    "autoBuild": {
      "inProgressTitle": "កំពុងដំណើរការស្វ័យប្រវត្តិ",
      "phase": {
        "waiting": "1/3 រង់ចាំ — កំពុងរង់ចាំវេនរបស់ម៉ាស៊ីនមេដំណើរការ។",
        "processing": "2/3 ដំណើរការ — កំពុងទទួលរូបថត និង GCP ហើយបង្កើតលទ្ធផល។",
        "publishing": "3/3 បញ្ចូលលទ្ធផល — កំពុងផ្ទុកឡើងលទ្ធផលដែលបានបង្កើត។"
      },
      "phaseUnknown": "កំពុងដំណើរការដោយការកសាងស្វ័យប្រវត្តិ។",
      "completed": "បានបញ្ចប់ដោយការកសាងស្វ័យប្រវត្តិ",
      "handedOverTitle": "បុគ្គលិករបស់យើងនឹងដំណើរការជំនួសការកសាងស្វ័យប្រវត្តិ",
      "reasonUnknown": "បុគ្គលិករបស់យើងនឹងបន្តដំណើរការ។",
      "reasons": {
        "markers": {
          "what": "រកមិនឃើញសញ្ញាសម្គាល់គ្រប់គ្រាន់ ឬសញ្ញាសម្គាល់មិនបានគ្របដណ្តប់តំបន់ថតឱ្យស្មើគ្នា។",
          "nextTime": "វគ្គក្រោយ សូមហោះហើរទាបល្មមឱ្យ GSD {{gcpGsdLimitCm}} cm ឬតិចជាងនេះ ហើយដាក់សញ្ញាសម្គាល់ 6 ឡើងទៅ (យ៉ាងតិច 5) នៅកន្លែងគ្មានស្រមោល ឱ្យស្មើគ្នារហូតដល់ជ្រុងនៃតំបន់ថត។ ក្នុងឯកសារ GCP សូមសរសេរតែចំណុចដែលបានដាក់សញ្ញាសម្គាល់ប៉ុណ្ណោះ។"
        },
        "gcp_file": {
          "what": "មិនអាចអានឯកសារ GCP បាន ឬកូអរដោនេមិនត្រូវនឹងតំបន់ថត។",
          "nextTime": "វគ្គក្រោយ សូមផ្ទុកឡើងឯកសារ $t(timeSeries.gcpGuide.readableFormats) ដែលសរសេរ ស្លាក, X, Y, Z ក្នុងមួយជួរ ជាកូអរដោនេ EPSG:5185–5188។"
        },
        "photos": {
          "what": "រូបថតមិនបំពេញលក្ខខណ្ឌនៃការកសាងស្វ័យប្រវត្តិ។",
          "nextTime": "វគ្គក្រោយ សូមថតដោយយន្តហោះដែលអនុញ្ញាត ($t(timeSeries.gcpGuide.allowedAircraft)) ក្នុងស្ថានភាព RTK fixed ដោយប្រើកាមេរ៉ា RGB មុំធំតែមួយ និងការត្រួតគ្នាទិសដៅហោះយ៉ាងតិច 65% និងចំហៀងយ៉ាងតិច 60%។"
        },
        "accuracy": {
          "what": "លទ្ធផលផ្គូផ្គងមិនបានបំពេញកម្រិតភាពត្រឹមត្រូវ។",
          "nextTime": "វគ្គក្រោយ សូមពិនិត្យថាបានវាស់ចំណុចកណ្តាលនៃសញ្ញាសម្គាល់ ហើយកម្ពស់ជាកម្ពស់ orthometric (KNGeoid)។"
        },
        "internal": {
          "what": "មិនអាចបញ្ចប់ការកសាងស្វ័យប្រវត្តិបាន ដោយសារបញ្ហារបស់ម៉ាស៊ីនមេដំណើរការ។",
          "nextTime": "វគ្គក្រោយ អ្នកអាចបន្តប្រើការរកឃើញស្វ័យប្រវត្តិដដែល។"
        }
      }
    },
    "autoBuildRejected": {
      "AUTO_BUILD_UNAVAILABLE": "បរិស្ថាននេះមិនប្រើការកសាងស្វ័យប្រវត្តិទេ។",
      "AUTO_DETECT_OFF": "ការរកឃើញស្វ័យប្រវត្តិត្រូវបានបិទ ដូច្នេះមិនអាចស្នើសុំការកសាងស្វ័យប្រវត្តិបានទេ។ សូមបើក [$t(timeSeries.gcpAutoDetect)] នៅជួរ GCP ហើយស្នើសុំម្តងទៀត។",
      "GCP_FILE_MISSING": "គ្មានឯកសារ GCP ដូច្នេះមិនអាចប្រើការកសាងស្វ័យប្រវត្តិបានទេ។ សូមផ្ទុកឡើងឯកសារ GCP នៅជួរ GCP។",
      "GCP_FILE_UNREADABLE": "មានឯកសារ GCP ដែលការកសាងស្វ័យប្រវត្តិមិនអាចអានបាន។ សូមរក្សាទុកជា $t(timeSeries.gcpGuide.readableFormats) ហើយផ្ទុកឡើងម្តងទៀត។",
      "NO_PHOTOS": "គ្មានរូបថតដ្រូន ដូច្នេះមិនអាចប្រើការកសាងស្វ័យប្រវត្តិបានទេ។",
      "AUTO_DETECT_LOCKED": "មិនអាចផ្លាស់ប្តូរការរកឃើញស្វ័យប្រវត្តិបានទេ បន្ទាប់ពីស្នើសុំការគូសផែនទី។",
      "NO_RGB_PHOTOS": "គ្មានរូបថត RGB ដែលការកសាងស្វ័យប្រវត្តិអាចដំណើរការបានទេ (មានតែរូបថតកម្ដៅ ឬរូបថតដែលមិនអាចអានបាន)។ សម្រាប់វគ្គនេះ សូមស្នើសុំដោយមិនប្រើ [$t(timeSeries.gcpAutoDetect)] ហើយបុគ្គលិករបស់យើងនឹងដំណើរការ។ លក្ខខណ្ឌថតមាននៅក្នុង $t(timeSeries.gcpGuide.title)។",
      "MULTI_SENSOR": "មានរូបថតពីកាមេរ៉ាច្រើនលាយគ្នា ដូច្នេះមិនអាចប្រើការកសាងស្វ័យប្រវត្តិបានទេ (ទទួលតែរូបថតពីកាមេរ៉ា RGB មុំធំតែមួយប៉ុណ្ណោះ)។ សម្រាប់វគ្គនេះ សូមស្នើសុំដោយមិនប្រើ [$t(timeSeries.gcpAutoDetect)] ហើយបុគ្គលិករបស់យើងនឹងដំណើរការ។ លក្ខខណ្ឌថតមាននៅក្នុង $t(timeSeries.gcpGuide.title)។",
      "DRONE_UNSUPPORTED": "រូបថតត្រូវបានថតដោយយន្តហោះដែលការកសាងស្វ័យប្រវត្តិមិនគាំទ្រ។ យន្តហោះដែលគាំទ្រ៖ $t(timeSeries.gcpGuide.allowedAircraft)។ សម្រាប់វគ្គនេះ សូមស្នើសុំដោយមិនប្រើ [$t(timeSeries.gcpAutoDetect)] ហើយបុគ្គលិករបស់យើងនឹងដំណើរការ។ លក្ខខណ្ឌថតមាននៅក្នុង $t(timeSeries.gcpGuide.title)។",
      "NO_GNSS": "មានរូបថតដែលគ្មានទីតាំង GNSS ក្នុង EXIF ដូច្នេះមិនអាចប្រើការកសាងស្វ័យប្រវត្តិបានទេ។ សម្រាប់វគ្គនេះ សូមស្នើសុំដោយមិនប្រើ [$t(timeSeries.gcpAutoDetect)] ហើយបុគ្គលិករបស់យើងនឹងដំណើរការ។ លក្ខខណ្ឌថតមាននៅក្នុង $t(timeSeries.gcpGuide.title)។",
      "RTK_NOT_FIXED": "មានរូបថតដែលមិនបានថតក្នុងស្ថានភាព RTK fixed ដូច្នេះមិនអាចប្រើការកសាងស្វ័យប្រវត្តិបានទេ។ សម្រាប់វគ្គនេះ សូមស្នើសុំដោយមិនប្រើ [$t(timeSeries.gcpAutoDetect)] ហើយបុគ្គលិករបស់យើងនឹងដំណើរការ។ លក្ខខណ្ឌថតមាននៅក្នុង $t(timeSeries.gcpGuide.title)។"
    },
    "autoBuildRejectedUnknown": "មិនអាចប្រើការកសាងស្វ័យប្រវត្តិសម្រាប់ទិន្នន័យនេះបានទេ។ សូមស្នើសុំដោយមិនប្រើ [$t(timeSeries.gcpAutoDetect)] ហើយបុគ្គលិករបស់យើងនឹងដំណើរការ។",
    "mappingRequestResult": {
      "succeeded": "ការស្នើសុំការគូសផែនទីបានបញ្ចប់។",
      "alreadyRequested": "វគ្គនេះបានស្នើសុំការគូសផែនទីរួចហើយ ឬកំពុងដំណើរការ។",
      "failed": "ការស្នើសុំការគូសផែនទីបានបរាជ័យ។"
    },
    "mappingAutoBuildNotice": "ការរកឃើញ GCP ស្វ័យប្រវត្តិត្រូវបានបើក ដូច្នេះការគូសផែនទីនឹងដំណើរការដោយស្វ័យប្រវត្តិ។",
    "mappingRequestModal": {
      "title": "តើអ្នកចង់ស្នើសុំការគូសផែនទីរូបភាពទេ?",
      "description": "បន្ទាប់ពីស្នើសុំការគូសផែនទី អ្នកមិនអាចលុបរូបភាពចេញពីបញ្ជីរូបភាព ឬបញ្ចូលរូបភាពបន្ថែមបានទេ។",
      "confirm": "ស្នើសុំ",
      "autoBuildConditions": "ប្រសិនបើលក្ខខណ្ឌណាមួយខាងក្រោមមិនគ្រប់គ្រាន់ បុគ្គលិករបស់យើងនឹងដំណើរការជំនួសវិញ ដែលត្រូវការពេលយូរជាង។",
      "turnOnAutoDetect": "ប្រសិនបើអ្នកបានដាក់សញ្ញាសម្គាល់ស្តង់ដាររបស់ DroneSquare មុនពេលថត សូមបើក [$t(timeSeries.gcpAutoDetect)] នៅជួរ GCP មុននឹងស្នើសុំ។",
      "manualThisTime": "បុគ្គលិករបស់យើងនឹងដំណើរការសំណើនេះ។"
    },
    "gcpGuide": {
      "open": "$t(timeSeries.gcpGuide.title)",
      "title": "មគ្គុទ្ទេសក៍ GCP រកឃើញស្វ័យប្រវត្តិ",
      "aircraft": {
        "m3e": "Mavic 3E",
        "m4": "Matrice 4E/4D",
        "p4rtk": "Phantom 4 RTK",
        "p1_35": "Zenmuse P1 35 mm"
      },
      "allowedAircraft": "$t(timeSeries.gcpGuide.aircraft.m3e), $t(timeSeries.gcpGuide.aircraft.m4), $t(timeSeries.gcpGuide.aircraft.p4rtk), $t(timeSeries.gcpGuide.aircraft.p1_35)",
      "readableFormats": "csv, txt ឬ xlsx",
      "unreadableFormats": "xls",
      "what": {
        "title": "អ្វីទៅជាការរកឃើញស្វ័យប្រវត្តិ",
        "items": [
          "ប្រសិនបើអ្នកដាក់សញ្ញាសម្គាល់ស្តង់ដាររបស់ DroneSquare នៅទីតាំង GCP មុនពេលថត ប្រព័ន្ធនឹងស្វែងរកសញ្ញាសម្គាល់ក្នុងរូបថត ហើយផ្គូផ្គង GCP ដោយស្វ័យប្រវត្តិ។ មិនចាំបាច់សម្គាល់ GCP លើរូបថតនីមួយៗទេ។"
        ]
      },
      "checklist": {
        "title": "លក្ខខណ្ឌសម្រាប់ដំណើរការស្វ័យប្រវត្តិ",
        "items": [
          "ដាក់សញ្ញាសម្គាល់ស្តង់ដាររបស់ DroneSquare (ជ្រុងម្ខាង {{gcpMarkerSideCm}} cm) យ៉ាងហោចណាស់ 5 ឱ្យស្មើៗគ្នា ហើយវាស់ចំណុចកណ្តាលនៃសញ្ញាសម្គាល់នៅថ្ងៃដែលដាក់។",
          "ថតដោយយន្តហោះ DJI RTK ($t(timeSeries.gcpGuide.allowedAircraft)) ក្នុងស្ថានភាព RTK fixed ដោយប្រើកាមេរ៉ា RGB មុំធំតែមួយ។",
          "ថតនៅ GSD {{gcpGsdLimitCm}} cm ឬតិចជាងនេះ។",
          "ក្នុងឯកសារ GCP ($t(timeSeries.gcpGuide.readableFormats)) សរសេរតែចំណុចដែលបានដាក់សញ្ញាសម្គាល់លើកនេះប៉ុណ្ណោះ។",
          "សរសេរកម្ពស់ (Z) ជាកម្ពស់ orthometric (KNGeoid)។"
        ]
      },
      "prepare": {
        "title": "ការរៀបចំសញ្ញាសម្គាល់",
        "printFile": "បោះពុម្ពតាមមាត្រដ្ឋាន 100% ឱ្យបានទំហំ {{gcpMarkerSideMm}} × {{gcpMarkerSideMm}} mm (តាមបន្ទាត់កាត់)។",
        "previewAlt": "រូបមើលជាមុននៃសញ្ញាសម្គាល់ស្តង់ដាររបស់ DroneSquare — បន្ទះការ៉េខ្មៅស 2×2 ដែលការ៉េខាងលើឆ្វេង និងខាងក្រោមស្តាំជាពណ៌ខ្មៅ",
        "downloadPdf": "ទាញយក PDF",
        "downloadSvg": "ទាញយក SVG",
        "downloadA1": "ទាញយក PDF ផ្ទាំង A1",
        "a1Note": "ឯកសារដែលបោះពុម្ពលើក្រដាស A1 ចំនួន 2 សន្លឹក ហើយភ្ជាប់គ្នា។",
        "items": [
          "សញ្ញាសម្គាល់គឺជាការ៉េខ្មៅស 2×2 ទំហំ {{gcpMarkerSideCm}} cm ក្នុងមួយជ្រុង។ ការ៉េខាងលើឆ្វេង និងខាងក្រោមស្តាំជាពណ៌ខ្មៅ គ្មានគែម និងគ្មានលេខ។ ណែនាំឱ្យប្រើប្រភេទម៉ាត់។",
          "បន្ទះលក់តាមហាងទំហំ {{gcpMarkerSideCm}} cm ដែលមានលំនាំដូចគ្នា ក៏អាចប្រើបានដែរ។ បន្ទះដែលមានគែម មានលេខ ឬមានលំនាំខុសគ្នា មិនអាចប្រើបានទេ។",
          "ប្រសិនបើធ្វើដោយខ្លួនឯង សូមបោះពុម្ពលើបដាម៉ាត់ ហើយដាក់រង្វង់ដែកសម្រាប់ចងនៅជ្រុងទាំងបួន។ រៀបចំឱ្យគ្រប់ចំនួន GCP។"
        ]
      },
      "install": {
        "title": "ការដំឡើង និងការវាស់វែង",
        "items": [
          "នៅថ្ងៃដែលដាក់សញ្ញាសម្គាល់ វាស់ចំណុចកណ្តាលនៃសញ្ញាសម្គាល់ (ចំណុចដែលការ៉េខ្មៅពីរប៉ះគ្នា)។",
          "លាតឱ្យរាបស្មើ ភ្ជាប់ជ្រុងទាំងបួនឱ្យជាប់ ហើយដាក់នៅកន្លែងដែលគ្មានទឹក ធូលី ឬស្រមោល។",
          "ដាក់ 6 ឡើងទៅ (យ៉ាងតិច 5) ឱ្យស្មើគ្នា រហូតដល់ជ្រុងនៃតំបន់ថត។ ប្រសិនបើផ្ទៃដែលសញ្ញាសម្គាល់ព័ទ្ធជុំវិញតិចជាង 30% នៃតំបន់ថត ដំណើរការស្វ័យប្រវត្តិនឹងមិនដំណើរការទេ។",
          "(ជម្រើស) ដើម្បីដាក់ចំណុចត្រួតពិនិត្យ សូមសរសេរក្នុងឯកសារ GCP៖ ចំណុចយោង GCP1, GCP2… និងចំណុចត្រួតពិនិត្យ CP1, CP2…។"
        ]
      },
      "flight": {
        "title": "ការហោះហើរ",
        "itemsBeforeTable": [
          "ថតនៅ GSD {{gcpGsdLimitCm}} cm ឬតិចជាងនេះ។ លើសពី {{gcpGsdFalloffCm}} cm សញ្ញាសម្គាល់នឹងពិបាករកឃើញ ហើយសំណើទំនងជាត្រូវបញ្ជូនទៅបុគ្គលិករបស់យើង។"
        ],
        "tableCaption": "កម្ពស់ប្រហាក់ប្រហែលដែល GSD ស្មើ {{gcpGsdLimitCm}} cm (គិតពីដី ពិនិត្យ GSD ក្នុងកម្មវិធីហោះហើរ)",
        "tableHeaders": {
          "aircraft": "យន្តហោះ",
          "altitude": "កម្ពស់ពីដី"
        },
        "tableRows": {
          "m3e": "$t(timeSeries.gcpGuide.aircraft.m3e) · $t(timeSeries.gcpGuide.aircraft.m4)",
          "p4rtk": "$t(timeSeries.gcpGuide.aircraft.p4rtk)",
          "p1_35": "$t(timeSeries.gcpGuide.aircraft.p1_35)"
        },
        "tableAltitude": "ប្រហែល {{meters}} m",
        "validatedRangeNote": "{{aircraft}}៖ ជាកម្ពស់ដែលបានផ្ទៀងផ្ទាត់រហូតដល់ {{meters}} m។",
        "itemsAfterTable": [
          "ការត្រួតគ្នា៖ ទិសដៅហោះយ៉ាងតិច 65% និងចំហៀងយ៉ាងតិច 60%។",
          "ធ្វើឱ្យសញ្ញាសម្គាល់នីមួយៗលេចឡើងពេញទាំងមូលក្នុងរូបថតយ៉ាងតិច 5 សន្លឹក។"
        ]
      },
      "upload": {
        "title": "ការបញ្ចូល និងការស្នើសុំ",
        "items": [
          "បញ្ចូលរូបថត និងឯកសារ GCP ដូចធម្មតា បើក [$t(timeSeries.gcpAutoDetect)] នៅជួរ GCP រួចស្នើសុំការធ្វើផែនទី។",
          "ឯកសារ GCP អានបានតែ $t(timeSeries.gcpGuide.readableFormats) ប៉ុណ្ណោះ (មិនអាចអាន $t(timeSeries.gcpGuide.unreadableFormats) បានទេ)។ សរសេរ ស្លាក, X, Y, Z ក្នុងមួយជួរ ហើយប្រព័ន្ធកូអរដោនេគឺ EPSG:5185–5188។ លំដាប់ X និង Y អាចជាបែបណាក៏បាន។",
          "សម្រាប់កម្ពស់ កុំប្រើតម្លៃដែលផ្អែកលើ TBM របស់ទីតាំង កម្រិតយោងទឹក (DL) ឬកម្ពស់អេលីបសូអ៊ីត។",
          "បញ្ចូលឯកសារ GCP សម្រាប់វគ្គនីមួយៗ (ទោះបីដូចវគ្គមុនក៏ដោយ)។"
        ]
      },
      "fallback": {
        "title": "នៅពេលដំណើរការស្វ័យប្រវត្តិមិនដំណើរការ",
        "items": [
          "ប្រសិនបើរកមិនឃើញសញ្ញាសម្គាល់គ្រប់គ្រាន់ ឬគុណភាពមិនដល់ស្តង់ដារ បុគ្គលិករបស់យើងនឹងដំណើរការតាមវិធីធម្មតា។",
          "គុណភាពលទ្ធផលដូចគ្នា ហើយអ្នកមិនចាំបាច់ធ្វើអ្វីទេ។"
        ]
      }
    },
    "completionDate": "ថ្ងៃបញ្ចប់",
    "coordinateSystem": "ប្រព័ន្ធកូអរដោនេចេញ",
    "resolution": "គុណភាព (GSD)",
    "images": "រូបភាព (ដែនបន្ថែម/ដើម)",
    "download": "ទាញយក",
    "preview": "មើលជាមុន",
    "orthomosaic": "រូបភាព Orthomosaic [TIF]",
    "pointCloud": "3D Point Cloud [LAS]",
    "mesh": "3D Mesh [OBJ]",
    "meshZip": "3D Mesh [OBJ] (.zip)",
    "dsm": "គំរូផ្ទៃ DSM [TIF]",
    "dsmZip": "គំរូផ្ទៃ DSM [TIF] (.zip)",
    "orthoDownload": {
      "optionsName": "ជម្រើសទាញយកផលិតផល",
      "loadFailed": "មិនអាចផ្ទុកជម្រើសទាញយកផលិតផលបានទេ",
      "remainingOf": "ចំនួនទាញយកនៅសល់ {{remaining}} / {{limit}}",
      "products": {
        "orthomosaic": "រូបភាព Orthomosaic",
        "dsm": "គំរូផ្ទៃ DSM [DSM-TIF]"
      },
      "files": {
        "dsmGeotiff": "DSM GeoTIFF (.tif)"
      },
      "unavailable": "គ្មាន",
      "unavailableNotice": "ជុំនេះគ្មានឯកសារនេះទេ។ បើត្រូវការ សូមទាក់ទងអ្នកទទួលខុសត្រូវ។",
      "geotiffGroup": "GeoTIFF (សម្រាប់ GIS)",
      "cadGroup": "កញ្ចប់ CAD (សម្រាប់ AutoCAD / Civil 3D)",
      "geotiffHelpLabel": "អំពី GeoTIFF",
      "cadHelpLabel": "អំពីកញ្ចប់ CAD",
      "geotiffHelp": "ឯកសារដើមមានគុណភាពបង្ហាញខ្ពស់ ដូច្នេះឯកសារធំ និងត្រូវការអង្គចងចាំច្រើនដើម្បីបើក។ យើងណែនាំឱ្យទាញយកកំណែបង្រួម 1/2 ឬ 1/4 ដែលសមនឹងគុណភាពបង្ហាញដែលអ្នកត្រូវការ និងកុំព្យូទ័ររបស់អ្នក។\n\nកំណែបង្រួមត្រូវបានបង្កើតម្តងនៅពេលស្នើសុំលើកដំបូង ហើយអាចចំណាយពេលច្រើននាទីឬយូរជាងនេះ អាស្រ័យលើទំហំរូបភាព។ បន្ទាប់ពីបង្កើតរួច អាចទាញយកបានភ្លាមៗ ហើយការបង្កើតមិនប្រើចំនួនទាញយកទេ។",
      "cadHelp": "ជាឯកសារ ZIP ដែលមាន PNG ឯកសារ world (.pgw) ប្រព័ន្ធកូអរដោនេ (.prj) DXF (រូបភាព ចំណុចកម្ពស់ និងស្លាកកម្ពស់) និង CSV ចំណុចកម្ពស់ (ចំណុច COGO សម្រាប់ Civil 3D)។ ពន្លាវា ហើយបើក DXF នោះរូបភាពនឹងបង្ហាញដោយស្វ័យប្រវត្តិនៅទីតាំងកូអរដោនេពិត ដូច្នេះមិនចាំបាច់កំណត់ទីតាំងឬទំហំដោយខ្លួនឯងទេ។\n\nកម្ពស់នៃចំណុចកម្ពស់គឺជា DSM។ វាជាកម្ពស់ផ្ទៃរួមទាំងអគារ ដើមឈើ និងឧបករណ៍ ជាម៉ែត្រ orthometric។ គ្មានចំណុចនៅកន្លែងដែលរូបភាពថ្លា ឬ DSM ទទេទេ។\n\nកញ្ចប់ CAD ត្រូវបានបង្កើតម្តងនៅពេលស្នើសុំលើកដំបូង ហើយអាចចំណាយពេលខ្លះ។",
      "elevationSpacingNotice": "ជុំនេះគ្របដណ្តប់តំបន់ធំទូលាយ ដូច្នេះចំណុចកម្ពស់ត្រូវបានដាក់រៀងរាល់ {{spacing}} m (លំនាំដើម 5 m)។",
      "optionLabel": "{{cm}} cm/px ({{variant}})",
      "variantOriginal": "ដើម",
      "variantScaled": "បង្រួម 1/{{scale}}",
      "pixels": "{{width}} × {{height}} px",
      "notGenerated": "មិនទាន់បង្កើត",
      "generate": "បង្កើត",
      "generateFor": "បង្កើត: {{option}}",
      "download": "ទាញយក",
      "downloadFor": "ទាញយក: {{option}}",
      "processing": "កំពុងបង្កើត",
      "processingFor": "កំពុងបង្កើត: {{option}}",
      "processingProgress": "កំពុងបង្កើត {{progress}}%",
      "failed": "បង្កើតបរាជ័យ",
      "ownerOnly": "មានតែម្ចាស់គម្រោង និងគណនីអ្នកគ្រប់គ្រងប៉ុណ្ណោះដែលអាចទាញយកផលិតផលបាន។",
      "limitExhausted": "បានប្រើចំនួនទាញយកអស់ហើយ។ សូមទាក់ទងអ្នកទទួលខុសត្រូវសម្រាប់ការទាញយកបន្ថែម។",
      "notReady": "ជម្រើសនេះមិនទាន់រួចរាល់ទេ។ ស្ថានភាពត្រូវបានផ្ទុកឡើងវិញ។",
      "concurrencyLimit": "មានការបង្កើតច្រើនពេកកំពុងដំណើរការ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។",
      "requestFailed": "សំណើទាញយកបរាជ័យ។ សូមព្យាយាមម្តងទៀត។",
      "confirm": {
        "title": "បញ្ជាក់ការទាញយក",
        "largeImageWarning": "រូបភាពនេះមានប្រហែល {{megapixels}} MP (លើសពី 100 លានភីកសែល)។ ឯកសារធំណាស់ ហើយត្រូវការអង្គចងចាំច្រើនដើម្បីបើក។",
        "originalSlowNotice": "អាស្រ័យលើកុំព្យូទ័រ និងទំហំរូបភាព ការទាញយកអាចយឺត។ បើមិនស្រួល សូមទាក់ទងមកយើងដោយឡែក។",
        "largeFileWarning": "ឯកសារនេះមានទំហំ {{size}}។ ការទាញយកត្រូវការពេលយូរ និងទំហំផ្ទុកទំនេរប៉ុណ្ណោះដែរ។",
        "cancel": "បោះបង់",
        "download": "ទាញយក"
      }
    }
  },
  "myPage": {
    "title": "ទំព័ររបស់ខ្ញុំ",
    "logout": "ចេញ",
    "menu": {
      "accountInfo": "ព័ត៌មានគណនី",
      "projectPermission": "គ្រប់គ្រងសិទ្ធិគម្រោង",
      "projectHistory": "ប្រវត្តិគម្រោង",
      "withdrawal": "លុបគណនី"
    },
    "account": {
      "title": "ព័ត៌មានគណនី",
      "name": "ឈ្មោះ",
      "email": "អ៊ីមែល",
      "organization": "ស្ថាប័ន",
      "phone": "លេខទូរស័ព្ទ",
      "field": "វិស័យ",
      "role": "តួនាទី",
      "password": "ពាក្យសម្ងាត់",
      "passwordConfirm": "បញ្ជាក់ពាក្យសម្ងាត់",
      "currentPassword": "ពាក្យសម្ងាត់បច្ចុប្បន្ន",
      "newPassword": "ពាក្យសម្ងាត់ថ្មី",
      "changePassword": "ផ្លាស់ប្ដូរពាក្យសម្ងាត់",
      "save": "រក្សាទុក",
      "cancel": "បោះបង់",
      "edit": "កែ",
      "timezone": "តំបន់ពេលវេលា",
      "timezoneAutoDetected": "(រកឃើញដោយស្វ័យប្រវត្តិពីកម្មវិធីរុករក)"
    },
    "permission": {
      "title": "គ្រប់គ្រងសិទ្ធិគម្រោង",
      "addUser": "បន្ថែមអ្នកប្រើ",
      "searchUser": "ស្វែងរកអ្នកប្រើ",
      "userEmail": "អ៊ីមែលអ្នកប្រើ",
      "permission": "សិទ្ធិ",
      "role": {
        "owner": "ម្ចាស់",
        "editor": "អ្នកកែ",
        "viewer": "អ្នកមើល"
      },
      "status": {
        "joined": "បានចូលរួម",
        "notJoined": "មិនទាន់ចូលរួម"
      },
      "actions": {
        "delete": "លុប",
        "edit": "កែ",
        "add": "បន្ថែម"
      },
      "table": {
        "email": "អ៊ីមែល",
        "name": "ឈ្មោះ",
        "permission": "សិទ្ធិ",
        "status": "ស្ថានភាពការចូលរួម",
        "actions": "ប្រតិបត្តិការ"
      }
    },
    "withdrawal": {
      "title": "លុបគណនី",
      "confirm": "លុបគណនី",
      "cancel": "បោះបង់"
    },
    "messages": {
      "passwordChanged": "ពាក្យសម្ងាត់បានផ្លាស់ប្ដូរ",
      "passwordChangeFailed": "ការផ្លាស់ប្ដូរពាក្យសម្ងាត់បានបរាជ័យ",
      "accountUpdated": "ព័ត៌មានគណនីបានធ្វើបច្ចុប្បន្នភាព",
      "accountUpdateFailed": "ការធ្វើបច្ចុប្បន្នភាពព័ត៌មានគណនីបានបរាជ័យ",
      "userAdded": "បានបន្ថែមអ្នកប្រើ",
      "userAddFailed": "ការបន្ថែមអ្នកប្រើបានបរាជ័យ",
      "userDeleted": "បានលុបអ្នកប្រើ",
      "userDeleteFailed": "ការលុបអ្នកប្រើបានបរាជ័យ",
      "permissionUpdated": "សិទ្ធិបានធ្វើបច្ចុប្បន្នភាព",
      "permissionUpdateFailed": "ការធ្វើបច្ចុប្បន្នភាពសិទ្ធិបានបរាជ័យ",
      "accountDeleteFailed": "ការលុបគណនីបានបរាជ័យ",
      "ownerTransferred": "កម្មសិទ្ធិត្រូវបានផ្ទេររួចរាល់",
      "confirmDelete": "តើអ្នកពិតជាចង់លុបមែនទេ?",
      "confirmWithdrawal": "តើអ្នកពិតជាចង់លុបគណនីមែនទេ?",
      "projectInfoUpdated": "ព័ត៌មានគម្រោងបានធ្វើបច្ចុប្បន្នភាព",
      "projectInfoUpdateFailed": "ការធ្វើបច្ចុប្បន្នភាពព័ត៌មានគម្រោងបានបរាជ័យ",
      "timeSeriesUpdated": "ព័ត៌មានស៊េរីពេលវេលាបានធ្វើបច្ចុប្បន្នភាព",
      "timeSeriesUpdateFailed": "ការធ្វើបច្ចុប្បន្នភាពស៊េរីពេលវេលាបានបរាជ័យ",
      "reset": "កំណត់ឡើងវិញ"
    },
    "history": {
      "sentence": {
        "create": "{{actor}} បានបន្ថែម {{target}}",
        "register": "{{actor}} បានផ្ទុកឡើង {{target}}",
        "update": "{{actor}} បានកែប្រែ {{type}} ទៅជា \"{{name}}\"",
        "delete": "{{actor}} បានលុប {{target}}",
        "generic": "{{actor}} · {{target}}",
        "memberWithdrawn": "{{actor}} បានចាកចេញពីគម្រោង ដោយសារបានលុបគណនី"
      },
      "type": {
        "project": "គម្រោង",
        "time_project": "ស៊េរីពេលវេលា",
        "member": "សមាជិក",
        "annotation": "ចំណាំ",
        "annotation_comment": "មតិយោបល់",
        "annotation_comment_image": "រូបភាពមតិយោបល់",
        "category": "ប្រភេទ",
        "vector": "ការវាស់ 3D",
        "clipping": "មុខកាត់ 3D",
        "worksite_zone": "តំបន់ហាមឃាត់",
        "geolog": "GeoLog",
        "walk_session": "ការថតដើរ",
        "layer": "ស្រទាប់",
        "drawing_mesh": "គំនូរបច្ចេកទេស",
        "folder": "ថត",
        "project_equipment": "ឧបករណ៍ និងសំណង់",
        "height_profile_record": "ចន្លោះផ្នែកបណ្ដោយ",
        "height_profile_export": "នាំចេញផ្នែកបណ្ដោយ"
      },
      "name": {
        "timeProject": "ថ្ងៃថត {{name}}",
        "walkSession": "វគ្គ {{name}}"
      },
      "timeProjectFallback": "ស៊េរីពេលវេលា #{{id}}",
      "empty": "គ្មានកំណត់ត្រាទេ",
      "emptyFiltered": "គ្មានកំណត់ត្រាប្រភេទនេះទេ",
      "noProject": "គ្មានគម្រោងដែលបានចូលរួមទេ",
      "forbidden": "អ្នកគ្មានសិទ្ធិមើលកំណត់ត្រារបស់គម្រោងនេះទេ",
      "error": "បរាជ័យក្នុងការផ្ទុកកំណត់ត្រា",
      "retry": "ព្យាយាមម្តងទៀត",
      "loadMore": "ផ្ទុកបន្ថែម"
    }
  },
  "fileList": {
    "dragAndDrop": "ទាញ និងទម្លាក់ឯកសារ",
    "or": "ឬ",
    "selectFile": "ជ្រើសរើសឯកសារ"
  },
  "status": {
    "before": "មុនដំណើរការ",
    "requested": "សំណើបានបញ្ចប់",
    "onProcessing": "កំពុងដំណើរការ",
    "failed": "ដំណើរការបរាជ័យ",
    "reviewing": "កំពុងពិនិត្យ",
    "completed": "ដំណើរការបានបញ្ចប់",
    "completed2d": "2D បានបញ្ចប់",
    "completed3d": "3D បានបញ្ចប់"
  },
  "droneImageTabs": {
    "list": "បញ្ជីបញ្ចូលបានបញ្ចប់",
    "add": "បន្ថែមរូបភាព"
  },
  "projectPermission": {
    "selectProject": "ជ្រើសរើសគម្រោង",
    "addMember": "បន្ថែមសមាជិក",
    "saveChanges": "រក្សាទុក",
    "resetChanges": "កំណត់ឡើងវិញ",
    "loading": "កំពុងផ្ទុកបញ្ជីគម្រោង...",
    "transferOwner": "ផ្ទេរកម្មសិទ្ធិ"
  }
} as const;

export default projects;
